import React, { useState } from "react";

const faqs = [
  {
    question: "Are cancellations due to COVID-19 refundable?",
    answer:
      "Yes, we offer full refunds for cancellations due to COVID-19.",
  },
  {
    question: "Do you match competitor prices?",
    answer:
      "We strive to offer the best prices and will match competitor rates.",
  },
  {
    question: "Can I book a car for someone else?",
    answer:
      "Yes, you can book a rental for someone else, as long as they meet all the required criteria.",
  },
  {
    question: "What is the refund policy?",
    answer: "Refunds are available within a specified period as outlined in our terms and conditions.",
  },
  {
    question: "Are there any taxes?",
    answer:
      "Yes, applicable taxes will be added to the rental price.",
  },
  {
    question: "Can I rent an electric vehicle?",
    answer:
      "Absolutely! We offer several electric vehicle options, including models like the Tesla Model 3.",
  },
  {
    question: "How old do I have to be to rent a car?",
    answer:
      "Renters must be at least 21 years old with a valid driver’s license.",
  },
  {
    question: "Do you accept walk-ins?",
    answer:
      "Yes, we accept walk-ins at our New York locations. However, booking in advance is recommended to ensure availability.",
  },
  {
    question: "How much does it cost to rent a car?",
    answer:
      "Prices vary by car model and rental duration. Please refer to our vehicle listings for detailed pricing.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-black text-white py-16 px-6  mx-auto">
      <h2 className="text-center text-3xl font-bold mb-6">
        Frequently Asked Questions
      </h2>
      <div>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`bg-[#191919] rounded-lg my-2 overflow-hidden transition-all duration-300 ${
              openIndex === index ? "border-l-4 border-[#d4af37]" : ""
            }`}
          >
            <button
              className="flex justify-between items-center w-full px-6 py-4 text-lg font-semibold text-white  transition"
              onClick={() => handleToggle(index)}
            >
              <span>
                {index + 1}. {faq.question}
              </span>
              <span className="text-[#d4af37]">
                {openIndex === index ? (
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.1191 1.70697L12.7051 0.292969L7.41208 5.58597L2.11908 0.292969L0.705078 1.70697L5.99808 6.99997L0.705078 12.293L2.11908 13.707L7.41208 8.41397L12.7051 13.707L14.1191 12.293L8.82608 6.99997L14.1191 1.70697Z"
                      fill="url(#paint0_linear_2081_27397)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_2081_27397"
                        x1="-1.73532"
                        y1="-2.73547"
                        x2="18.7261"
                        y2="1.06873"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#d4af37" />
                        <stop offset="1" stop-color="#d4af37" />
                      </linearGradient>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.4121 7H9.41211V0H7.41211V7H0.412109V9H7.41211V16H9.41211V9H16.4121V7Z"
                      fill="url(#paint0_linear_2081_27403)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_2081_27403"
                        x1="-2.49876"
                        y1="-3.61227"
                        x2="21.9073"
                        y2="0.925316"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#d4af37" />
                        <stop offset="1" stop-color="#d4af37" />
                      </linearGradient>
                    </defs>
                  </svg>
                )}
              </span>
            </button>
            {openIndex === index && (
              <div className="px-6 pb-4 text-gray-400 text-sm">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
